export default "__VITE_ASSET__Bnk9vsoB__"